import React, { useState } from 'react';
import { useAxios } from '../../utils/useAxios';
import { CircularProgress } from '@mui/material';

const FileUploader = () => {
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [uploadErrors, setUploadErrors] = useState("");
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const axios = useAxios();

    const handleFileChange = (event) => {
        setFiles(Array.from(event.target.files));
        setUploadErrors("");
        setUploadSuccess(false);
        event.target.value = '';
    };

    // Funzione per rimuovere un file dalla lista
    const removeFile = (indexToRemove) => {
        setFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToRemove));
        setUploadErrors("");
        setUploadSuccess(false);
    };

    const handleUpload = async () => {
        if (files.length === 0) return;

        setUploading(true);
        setUploadErrors("");
        setUploadSuccess(false);

        try {
            const formData = new FormData();
            files.forEach((file) => {
                formData.append('Files', file);

            });

            const response = await axios.patch('clouddataupdate/UploadDocuments', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data === true) {
                setUploadSuccess(true);
                setFiles([]);
            } else {
                setUploadErrors(response.data.message);
            }
        } catch (error) {
            setUploadErrors(error.response.data.message);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div
            style={{
                maxWidth: '80%',
                margin: '30px auto',
                padding: 20,
                border: '2px solid #4a90e2',
                borderRadius: 8,
                backgroundColor: '#f0f8ff',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                textAlign: 'center',
            }}
        >
            <label
                htmlFor="file-upload"
                style={{
                    display: 'inline-block',
                    padding: '10px 20px',
                    backgroundColor: '#4a90e2',
                    color: '#fff',
                    borderRadius: 5,
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: 16,
                    userSelect: 'none',
                }}
            >
                Select files
            </label>
            <input
                id="file-upload"
                type="file"
                multiple
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />

            {files.length > 0 && (
                <div style={{ marginTop: 20, textAlign: 'left' }}>
                    <h4>Selected files:</h4>
                    <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
                        {files.map((file, index) => (
                            <li
                                key={index}
                                style={{
                                    padding: '6px 0',
                                    borderBottom: '1px solid #ddd',
                                    fontSize: 16,
                                    color: '#333',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <span>
                                    {file.name} ({(file.size / 1024).toFixed(2)} KB)
                                </span>
                                <button
                                    onClick={() => removeFile(index)}
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        color: '#ff4d4d',
                                        fontWeight: 'bold',
                                        cursor: 'pointer',
                                        fontSize: 18,
                                        lineHeight: '1',
                                        padding: '0 6px',
                                    }}
                                    aria-label={`Remove file ${file.name}`}
                                    title="Remove file"
                                >
                                    ×
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {files.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                    <button
                        onClick={handleUpload}
                        disabled={uploading}
                        style={{
                            padding: '10px 30px',
                            backgroundColor: uploading ? '#6ba3f0' : '#4a90e2',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 5,
                            cursor: uploading ? 'not-allowed' : 'pointer',
                            fontWeight: '600',
                            fontSize: 16,
                            userSelect: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                        }}
                    >
                        {uploading && (
                            <CircularProgress 
                                size={16} 
                                sx={{ color: '#fff' }} 
                            />
                        )}                    
                        {uploading ? 'Processing...' : 'Upload'}
                    </button>
                </div>
            )}

            {uploadErrors != "" && (
                <div
                    style={{
                        marginTop: 20,
                        backgroundColor: '#ffe6e6',
                        padding: 15,
                        borderRadius: 6,
                        border: '1px solid #ff4d4d',
                        color: '#d8000c',
                        fontWeight: '600',
                        textAlign: 'left',
                        whiteSpace: 'pre-wrap'
                    }}
                >
                    {uploadErrors}
                </div>
            )}

            {uploadSuccess && (
                <div
                    style={{
                        marginTop: 20,
                        backgroundColor: '#e6ffea',
                        padding: 15,
                        borderRadius: 6,
                        border: '1px solid #2ecc71',
                        color: '#27ae60',
                        fontWeight: '600',
                    }}
                >
                Data uploaded and processed successfully!
                </div>
            )}
        </div>
    );
};

export default FileUploader;
